export type PlayerCalendarStatus = 'playing' | 'tentative' | 'available' | 'maybe' | 'not_available' | 'going' | 'not_going' | 'none';

export type PlayerCalendarStatusItem = {
  kind: 'match' | 'event';
  ownAvailability?: 'available' | 'maybe' | 'not_available' | 'unknown';
  ownRsvp?: 'Going' | 'Maybe' | 'Not Going' | 'No Response';
  // Set by the server after checking canonical player ID, playable position,
  // and committed lineup status. Draft preview visibility is deliberately not
  // sufficient to make a player "Playing".
  isPlayerPlaying?: boolean;
  isPlayerTentative?: boolean;
};

/** Returns the player's saved response without inferring any lineup state. */
export function getPlayerResponseStatus(item: PlayerCalendarStatusItem): Exclude<PlayerCalendarStatus, 'playing' | 'tentative'> {
  if (item.kind === 'match') {
    if (item.ownAvailability === 'available') return 'available';
    if (item.ownAvailability === 'maybe') return 'maybe';
    if (item.ownAvailability === 'not_available') return 'not_available';
    return 'none';
  }
  if (item.ownRsvp === 'Going') return 'going';
  if (item.ownRsvp === 'Maybe') return 'maybe';
  if (item.ownRsvp === 'Not Going') return 'not_going';
  return 'none';
}

/**
 * Calendar-specific precedence: a committed server-authorized assignment is
 * more useful than the underlying response for the same match. Only a
 * server-authorized personal tentative assignment qualifies for blue.
 */
export function getPlayerCalendarStatus(item: PlayerCalendarStatusItem): PlayerCalendarStatus {
  if (item.kind === 'match' && item.isPlayerPlaying) return 'playing';
  if (item.kind === 'match' && item.isPlayerTentative) return 'tentative';
  return getPlayerResponseStatus(item);
}
